import React from "react";

const Gmat = () => {
  return <div>Gmat</div>;
};

export default Gmat;
